import React, { Fragment } from 'react';
import { Card, Icon, List, ListItem } from 'semantic-ui-react';

export const SierraViewError = () => (
  <Fragment>
    <Card className="card-jmb">
      <Card.Content className="header ean">
        <Card.Header textAlign="left">
          <Icon name="car" />
          Rental Details (Error)
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <List divided relaxed>
          <ListItem>
            <List.Header>
              <strong>Error</strong>
            </List.Header>
            <List.Description>Error displaying rental details</List.Description>
          </ListItem>
        </List>
      </Card.Content>
    </Card>
  </Fragment>
);
